export const columns = [
  {
    title: '呼出人',
    dataIndex: 'callerType',
    key: 'callerType',
    align: 'left',
    width: 150,
    slots: {
      customRender: 'callerType'
    }
  },
  {
    title: '接听人',
    dataIndex: 'calleeName',
    key: 'calleeName',
    align: 'left',
    width: 150,
    slots: {
      customRender: 'calleeName'
    }
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    align: 'left'
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    align: 'left'
  },
  {
    title: '电话时长',
    dataIndex: 'duration',
    key: 'duration',
    align: 'left',
    slots: {
      customRender: 'duration'
    }
  },

  {
    title: '拨号诉求',
    dataIndex: 'dialIntentStr',
    key: 'dialIntentStr',
    align: 'left',
    customRender: ({ text }) => {
      console.log(`output->dialIntentStr`, text)
      return text || '--'
    }
  },
  {
    title: '实际诉求',
    dataIndex: 'actualIntentStr',
    key: 'actualIntentStr',
    align: 'left',
    customRender: ({ text }) => {
      return text || '--'
    }
  },
  {
    title: '通话状态',
    dataIndex: 'endStatusDesc',
    key: 'endStatusDesc',
    align: 'left',
    slots: {
      customRender: 'endStatusDesc'
    }
  },
  {
    title: '未接来电处理标记',
    dataIndex: 'processingFlag',
    key: 'processingFlag',
    align: 'left',
    slots: {
      customRender: 'processingFlag'
    }
  },
  {
    title: '标记处理人',
    dataIndex: 'processingName',
    key: 'processingName',
    align: 'left'
  },
  {
    title: '处理时间',
    dataIndex: 'processingTime',
    key: 'processingTime',
    align: 'left',
    sorter: true
  },
  {
    title: '关联工单',
    dataIndex: 'action',
    key: 'action',
    align: 'left',
    slots: {
      customRender: 'action'
    }
  },
  // {
  //   title: '服务事项',
  //   dataIndex: 'serviceMatters',
  //   key: 'serviceMatters',
  //   align: 'left',
  //   slots: {
  //     customRender: 'serviceMatters'
  //   }
  // },
  {
    title: 'AI小结',
    dataIndex: 'chatSummaryStatus',
    align: 'left',
    customRender: ({ text }) => {
      const arr = ['生成失败', '已生成', '生成中'] //   0-失败 1-成功 2-生成中
      return arr[text]
    }
  },
  {
    title: '操作',
    dataIndex: 'call',
    fixed: 'right',
    key: 'call',
    align: 'left',
    width: 230,
    slots: {
      customRender: 'call'
    }
  }
]
export const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
export const redTextStatus = [
  'unconnected',
  'ivrGiveUp',
  'noSeatOnline',
  'notAnswer',
  'userReject',
  'powerOff',
  'busy',
  'outOfCredit',
  'ivrEnd'
]
export const processingFlagMap = [
  { label: '全部', value: '' },
  { label: '未处理', value: 0 },
  { label: '已处理', value: 1 }
]

// 通话方向筛选项枚举
export const directionFlagMap = [
  { label: '全部通话类型', value: '' },
  { label: '接听', value: 0 },
  { label: '呼出', value: 1 }
]
